unit Unit1;

interface

uses
  System.SysUtils, System.Classes, JS, Web,
  Vcl.ComCtrls, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.ExtCtrls, WEBLib.Slider, WEBLib.ComCtrls, WEBLib.StdCtrls, WEBLib.TreeNodes;

type
  TForm1 = class(TForm)
    WebImageSlider1: TImageSlider;
    WebMemo1: TMemo;
    WebTreeView1: TTreeView;
    WebSplitter1: TSplitter;
    procedure WebFormCreate(Sender: TObject);
    procedure WebTreeView1DblClickNode(Sender: TObject; ANode: TTreeNode);
    procedure WebImageSlider1ImageClick(Sender: TObject; ImageIndex: Integer);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}

procedure TForm1.WebFormCreate(Sender: TObject);
var TN1:TTreeNode;
begin
Caption:='Μηνάς Τζοβάρας & ΣΙΑ Ε.Ε.';
WebImageSlider1.Color:=clWebSteelBlue;
WebImageSlider1.Appearance.NavigationStyle:=navsBullets;
WebSplitter1.Color:=clWebRed;
WebMemo1.Color:=clWebLightCyan;
WebMemo1.AutoSize:=True;
WebMemo1.ReadOnly:=True;
//
WebImageSlider1.ImageURLs.Clear;
WebImageSlider1.ImageURLs.Add('./images/intro/delphi.webp');
WebImageSlider1.ImageURLs.Add('./images/intro/tools.jpg');
WebImageSlider1.ImageURLs.Add('./images/intro/hr.jpg');
WebImageSlider1.ImageURLs.Add('./images/intro/clients.jpg');
WebImageSlider1.RefreshImages;
//
WebMemo1.BeginUpdate;
WebMemo1.Clear;
WebMemo1.Lines.LoadFromFile('./images/intro/text.txt');
WebMemo1.EndUpdate;
//
WebTreeView1.BeginUpdate;
TN1:=WebTreeView1.Items.Add('Αρχική σελίδα');
TN1:=WebTreeView1.Items.Add('Λογισμικά αιολικών πάρκων');
WebTreeView1.Items.AddChild(TN1,'');
WebTreeView1.Items.AddChild(TN1,'Ener1');
WebTreeView1.Items.AddChild(TN1,'Ener2');
WebTreeView1.Items.AddChild(TN1,'Ener3 - Remote3');
WebTreeView1.Items.AddChild(TN1,'Λογισμικό για λήψη και εφαρμογή εντολών τηλε-εποπτείας/ελέγχου Σταθμών ΑΠΕ');
WebTreeView1.Items.AddChild(TN1,'');
TN1:=WebTreeView1.Items.Add('Λογισμικά μέτρησης αέριας ρύπανσης διυλιστηρίων');
WebTreeView1.Items.AddChild(TN1,'');
WebTreeView1.Items.AddChild(TN1,'ΒΕΑ');
WebTreeView1.Items.AddChild(TN1,'ΒΕΕ');
WebTreeView1.Items.AddChild(TN1,'ΒΕΕ STACK');
WebTreeView1.Items.AddChild(TN1,'ΒΕΕ CAirNet');
WebTreeView1.Items.AddChild(TN1,'');
TN1:=WebTreeView1.Items.Add('Μέτρηση και παρουσίαση Ταχύτητας Ανέμου');
TN1:=WebTreeView1.Items.Add('Relay control');
TN1:=WebTreeView1.Items.Add('Διαχείριση εκδηλώσεων');
TN1:=WebTreeView1.Items.Add('Επικοινωνία');
WebTreeView1.EndUpdate;
end;

procedure TForm1.WebImageSlider1ImageClick(Sender: TObject;
  ImageIndex: Integer);
begin
If ImageIndex=3 then
begin
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/intro/voyage.txt');
  WebMemo1.EndUpdate;
  //
  Realign;
end;
end;

procedure TForm1.WebTreeView1DblClickNode(Sender: TObject; ANode: TTreeNode);
begin
If ANode.Text='Αρχική σελίδα' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/intro/delphi.webp');
  WebImageSlider1.ImageURLs.Add('./images/intro/tools.jpg');
  WebImageSlider1.ImageURLs.Add('./images/intro/hr.jpg');
  WebImageSlider1.ImageURLs.Add('./images/intro/clients.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/intro/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='Λογισμικό για λήψη και εφαρμογή εντολών τηλε-εποπτείας/ελέγχου Σταθμών ΑΠΕ' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/wfcontrol/1.jpg');
  WebImageSlider1.ImageURLs.Add('./images/wfcontrol/2.jpg');
  WebImageSlider1.ImageURLs.Add('./images/wfcontrol/3.jpg');
  WebImageSlider1.ImageURLs.Add('./images/wfcontrol/4.jpg');
  WebImageSlider1.ImageURLs.Add('./images/wfcontrol/5.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/wfcontrol/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='Ener2' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/ener2/opcrtutcp.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/ener2/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='Ener3 - Remote3' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/ener3/ener31.png');
  WebImageSlider1.ImageURLs.Add('./images/ener3/ener32.png');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/ener3/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='ΒΕΑ' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/bea/empcda_new.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bea/bea2.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bea/bea3.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bea/bea4.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bea/bea5.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bea/bea6.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bea/bea7.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/bea/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='ΒΕΕ' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/bee/bee1.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bee/bee2.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bee/bee3.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bee/bee4.jpg');
  WebImageSlider1.ImageURLs.Add('./images/bee/bee5.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/bee/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='ΒΕΕ STACK' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/beek/calculated.jpg');
  WebImageSlider1.ImageURLs.Add('./images/beek/raw.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/beek/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='ΒΕΕ CAirNet' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/cairnet/cair1.png');
  WebImageSlider1.ImageURLs.Add('./images/cairnet/cair2.png');
  WebImageSlider1.ImageURLs.Add('./images/cairnet/cair11.png');
  WebImageSlider1.ImageURLs.Add('./images/cairnet/cair21.png');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/cairnet/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='Μέτρηση και παρουσίαση Ταχύτητας Ανέμου' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/ws/wscollect.jpg');
  WebImageSlider1.ImageURLs.Add('./images/ws/wsreport1.png');
  WebImageSlider1.ImageURLs.Add('./images/ws/wsreport2.png');
  WebImageSlider1.ImageURLs.Add('./images/ws/mobile.png');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/ws/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='Relay control' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/relay/relay1.jpg');
  WebImageSlider1.ImageURLs.Add('./images/relay/relay2.png');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/relay/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='Διαχείριση εκδηλώσεων' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/events/1.jpg');
  WebImageSlider1.ImageURLs.Add('./images/events/2.jpg');
  WebImageSlider1.ImageURLs.Add('./images/events/3.jpg');
  WebImageSlider1.ImageURLs.Add('./images/events/4.jpg');
  WebImageSlider1.ImageURLs.Add('./images/events/5.jpg');
  WebImageSlider1.ImageURLs.Add('./images/events/6.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/events/text.txt');
  WebMemo1.EndUpdate;
end;
If ANode.Text='Επικοινωνία' then
begin
  WebImageSlider1.ImageURLs.Clear;
  WebImageSlider1.ImageURLs.Add('./images/intro/delphi.webp');
  WebImageSlider1.ImageURLs.Add('./images/intro/tools.jpg');
  WebImageSlider1.ImageURLs.Add('./images/intro/hr.jpg');
  WebImageSlider1.ImageURLs.Add('./images/intro/clients.jpg');
  WebImageSlider1.RefreshImages;
  //
  WebMemo1.BeginUpdate;
  WebMemo1.Clear;
  WebMemo1.Lines.LoadFromFile('./images/intro/text1.txt');
  WebMemo1.EndUpdate;
end;
Realign;
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageSlider1 := TImageSlider.Create(Self);
  WebMemo1 := TMemo.Create(Self);
  WebTreeView1 := TTreeView.Create(Self);
  WebSplitter1 := TSplitter.Create(Self);

  WebImageSlider1.BeforeLoadDFMValues;
  WebMemo1.BeforeLoadDFMValues;
  WebTreeView1.BeforeLoadDFMValues;
  WebSplitter1.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 873;
    Height := 1519;
    Font.Charset := GREEK_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -16;
    Font.Name := 'Comic Sans MS';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebImageSlider1.SetParentComponent(Self);
    WebImageSlider1.Name := 'WebImageSlider1';
    WebImageSlider1.Left := 0;
    WebImageSlider1.Top := 0;
    WebImageSlider1.Width := 873;
    WebImageSlider1.Height := 400;
    WebImageSlider1.Appearance.NavigationStyle := navsThumbnails;
    WebImageSlider1.Appearance.TransitionEffect := tefSlide;
    WebImageSlider1.Appearance.Bullets.Opacity := 1.000000000000000000;
    WebImageSlider1.Appearance.Thumbnails.Opacity := 0.500000000000000000;
    WebImageSlider1.Appearance.Thumbnails.OpacityActive := 1.000000000000000000;
    SetEvent(WebImageSlider1, Self, 'OnImageClick', 'WebImageSlider1ImageClick');
    WebImageSlider1.Align := alTop;
    WebImageSlider1.Color := clWhite;
    WebMemo1.SetParentComponent(Self);
    WebMemo1.Name := 'WebMemo1';
    WebMemo1.Left := 0;
    WebMemo1.Top := 405;
    WebMemo1.Width := 873;
    WebMemo1.Height := 356;
    WebMemo1.Align := alTop;
    WebMemo1.HeightPercent := 100.000000000000000000;
    WebMemo1.Lines.BeginUpdate;
    try
      WebMemo1.Lines.Clear;
      WebMemo1.Lines.Add('WebMemo1');
    finally
      WebMemo1.Lines.EndUpdate;
    end;
    WebMemo1.SelLength := 0;
    WebMemo1.SelStart := 0;
    WebMemo1.WidthPercent := 100.000000000000000000;
    WebTreeView1.SetParentComponent(Self);
    WebTreeView1.Name := 'WebTreeView1';
    WebTreeView1.Left := 0;
    WebTreeView1.Top := 761;
    WebTreeView1.Width := 873;
    WebTreeView1.Height := 680;
    WebTreeView1.Align := alTop;
    WebTreeView1.HeightPercent := 100.000000000000000000;
    WebTreeView1.WidthPercent := 100.000000000000000000;
    WebTreeView1.TabOrder := 2;
    WebTreeView1.TabStop := True;
    SetEvent(WebTreeView1, Self, 'OnDblClickNode', 'WebTreeView1DblClickNode');
    WebSplitter1.SetParentComponent(Self);
    WebSplitter1.Name := 'WebSplitter1';
    WebSplitter1.Left := 0;
    WebSplitter1.Top := 400;
    WebSplitter1.Width := 873;
    WebSplitter1.Height := 5;
    WebSplitter1.Align := alTop;
    WebSplitter1.ChildOrder := 3;
    WebSplitter1.Color := clBtnFace;
  finally
    WebImageSlider1.AfterLoadDFMValues;
    WebMemo1.AfterLoadDFMValues;
    WebTreeView1.AfterLoadDFMValues;
    WebSplitter1.AfterLoadDFMValues;
  end;
end;

end.
